import {
  GET_FORMS_AWAITING_APPROVAL,
  FORM_DATA_LOADING,
  CLEAR_FORM_DATA
} from "./types";
import { API_BASE_URL } from "../utils/constants";
import axios from "axios";
import { notification } from "antd";

const getAPIforRole = role => {
  switch (role) {
    case "AED_MANAGER_1":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=adult_ed_federal_employee`;

    case "AED_MANAGER_2":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=adult_ed_state_employee`;

    case "AED_MANAGER_3":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=adult_ed_tanf_employee`;

    case "AED_MANAGER_4":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=adult_ed_el_civics_employee`;

    case "AED_DIR_COMPLIANCE":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=adult_ed_federal_manager,adult_ed_state_manager,adult_ed_tanf_manager,adult_ed_el_civics_manager`;

    case "AED_SAFE_ELT":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=adult_ed_federal_director,adult_ed_state_director,adult_ed_tanf_director,adult_ed_el_civics_director,safe_schools_doj_director`;

    case "HS_MANAGER_1":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=head_start_employee`;

    case "HS_DIR_COMPLIANCE":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=head_start_manager_1`;

    case "HS_ASSISTANT_DIR_OPS":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=head_start_operations_manager,head_start_nutrition_manager,head_start_health_family_manager,head_start_ed_special_service_manager,head_start_compliance_manager`;

    case "HS_OPS_MANAGER":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=head_start_center_manager`;

    case "HS_SENIOR_DIRECTOR":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=head_start_community_partnerships_manager,head_start_assistant_director_operations,head_start_assistant_director_childcare_partnerships`;

    case "HS_ELT":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=head_start_head_start_senior_director`;

    case "CASE_MANAGER_1":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=case_21_century_employee`;

    case "CASE_MANAGER_2":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=case_partnership_employee`;

    case "CASE_MANAGER_3":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=case_city_of_houston_employee`;

    case "CASE_MANAGER_4":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=case_endowment_employee`;

    case "CASE_DIR_COMPLIANCE":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=case_21_century_manager,case_partnership_manager,case_city_houston_manager,case_endowment_manager,case_21_century_assistant_director,case_partnership_assistant_director,case_city_of_houston_assistant_director,case_endowment_assistant_director`;

    case "CASE_ELT":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=case_21_century_director,case_partnership_director,case_city_of_houston_director,case_endowment_director`;

    case "SAFE_MANAGER_1":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=safe_schools_doj_employee`;

    case "SAFE_DIR_COMPLIANCE":
      return `${API_BASE_URL}/form/getFormsByApproval?approvals=safe_schools_manager`;
  }
};

export const getFormsAwaitingApproval = role => dispatch => {
  dispatch(setFormDataLoading());

  const api = getAPIforRole(role);

  axios
    .get(api, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(res =>
      dispatch({
        type: GET_FORMS_AWAITING_APPROVAL,
        payload: res.data
      })
    )
    .catch(err => {
      notification.error({
        message: "Failed to fetch data",
        description: err.response.data.message
      });
    });
};

export const setFormDataLoading = () => {
  return {
    type: FORM_DATA_LOADING
  };
};

export const clearFormData = () => {
  return {
    type: CLEAR_FORM_DATA,
    payload: {}
  };
};
